<template>
<div class="popup" v-cloak v-if="remoteCleanShow">
	
    <div class="content" id="remoteTaskClean">
        <div class="title">
            {{$t('language.common.cleanList')}}
            <div class="icon white-close dialog-close" @click="cancel()">
            </div>
        </div>
        <div class="remote-task-clean-content">
            <div class="remote-question">
                {{$t('language.common.sureCleanAll')}}
            </div>
            <div class="sure-botton">
                <button v-loading='loading' class="sure-button-two" @click="deleteAllOffLineTask()">{{$t('language.common.ok')}}</button>
                <button class="sure-button-one" @click="cancel()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            remoteCleanShow: false,
			offline:3,
			torrent:5,
			deletedCount:0,
			loading: false
        }
    },
    methods: {
        deleteAllOffLineTask() {
            let that = this;
			this.loading = true;
            let allData = this.$parent.offlineTaskData;
			let waitToDel = [];
			let runningData = [];
            for (let i = 0; i < allData.length; i++) {
				 var state = allData[i].result;
				 if(this.isRunOrWait(state)){
					  runningData.push(allData[i])
				 }else{
					 waitToDel.push(allData[i]);
				 }
			}
			if(waitToDel.length == 0){
				that.remoteCleanShow = false;
				that.loading = false;
				return;
			}
			let deleteData;
			let start = 0;
			this.del(start,waitToDel,function(){
				that.$store.commit("setRemoteTaskArr",that.$parent.offlineTaskData);
				that.remoteCleanShow = false;
				that.loading = false;
			});
        },
		del(start,waitToDel,callback){
			let that = this;
			let task = waitToDel[start];
			if(task.type == this.offline){
				this.deleteUrl(start,waitToDel,function(){
					if(start < waitToDel.length -1){
						that.del(start+1,waitToDel,callback);
					}else{
						callback();
					}
				});
			}
			if(task.type == this.torrent){
				this.deleteTorrent(start,waitToDel,function(){
					if(start < waitToDel.length -1){
						that.del(start+1,waitToDel,callback);
					}else{
						callback();
					}
				});
			}
		},
		cancel(){
			this.remoteCleanShow=false
		},
		isRunOrWait(state){
			let protectState = 'Waiting' + this.$parent.resultProtect;
			let isWait = 'Waiting' == state || protectState == state;
			let isRun = this.$parent.isRuning(state);
			if( isRun || isWait){
				return true;
			}
			return false;
		},
		deleteUrl(index,waitToDel,callback){
			let task = waitToDel[index];
			let deleteData = {
				ud: commonUtils.getUser().id,
				id: task.id,
				type: 3
			}
			let that = this;
			this.Utils.doTasksRequest("delete", deleteData).then(res => {  
				if (res.status == 200) {
			       that.searchIndexSplice(task.id);
			    }else if(res.status == 401){
					that.$toast({
					    text:  that.$t('language.exception.' + res.reason),
					    type: 'fail',
					    idValue: "remoteTask"
					});
				}
				callback();
			}, err => {
			    that.$toast({
			        text: err,
			        type: 'fail',
			        idValue: "remoteTask"
			    });
			});
		},
		deleteTorrent(index,waitToDel,callback){
			let task = waitToDel[index];
			let deleteData = {
				ud: commonUtils.getUser().id,
				id: task.id,
				type: 5
			}
			let that = this;
			this.Utils.doTorrentRequest("delete", deleteData).then(res => {
			    if (res.status == 200) {
					that.searchIndexSplice(task.id);
			    }
				callback();
			}, err => {
			    that.$toast({
			        text: err,
			        type: 'fail',
			        idValue: "remoteTask"
			    });
			});	
		},
		searchIndexSplice(taskId){
			let that = this;
			for (var i = 0; i < that.$parent.offlineTaskData.length; i++) {
				if(that.$parent.offlineTaskData[i].id == taskId){
					that.$parent.offlineTaskData.splice(i,1);
					break;
				}
			}
		}
    }
}
</script>

<style>
#remoteTaskClean {
    width: 416px;
    /*no*/
    height: 200px;
    /*no*/
}

.remote-task-clean-content {
    width: 100%;
    height: 140px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

.remote-question {
    margin-top: 20px;
    /*no*/
    text-align: center;
}

.sure-botton {
    width: 100%;
    margin-top: 32px;
    /*no*/
    vertical-align: middle;
    text-align: center;
}

.sure-button-one,.sure-button-one:hover{
    display: inline-block;
    width: 110Px;
    border-radius: 5Px;
    background: #fff;
    color: #5562b4;
    border: 1Px solid #5562b4;
}

.sure-button-two {
    display: inline-block;
    width: 110Px;
    border-radius: 5Px;
    margin-right: 25Px;
}

	#remoteTaskClean .el-loading-spinner .path {
		stroke: #5166BD !important;
	}

	#remoteTaskClean .el-table th>.cell {
		padding-right: 0 !important;
	}

	#remoteTaskClean .el-loading-spinner .circular {
		height: 0.3rem !important;
		width: 0.3rem !important;
	}

	#remoteTaskClean .el-loading-spinner {
		padding-top: 22px !important;
		/*no*/
	}

</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/remote_task_clean_popup.vue